export default __webpack_public_path__ + "static/media/Student_Member_ID_Card.78966964.jpg";